export default __webpack_public_path__ + "298d0dc439c94f4bb0c40ed6e050cb04.png";